export const META_INFO = {
    "/": {
      title: "Amerkila Spices - The Best Quality Spices Since 1985",
      description: "Amerkila Spices offers a range of premium, evergreen, blended, and pickle spices that are AGMARK-approved and roasted to perfection. Explore their delicious recipes and find their stores near you.",
      data: [{ name : "description", content : "Amerkila Spices offers a range of premium, evergreen, blended, and pickle spices that are AGMARK-approved and roasted to perfection. Explore their delicious recipes and find their stores near you."}]
    },
    "/about-us": {
      title: "About Us | Amerkila - The Legacy of Spices",
      description: "Learn more about Amerkila, a family-owned business that has been providing the best quality spices since 1985. Discover their vision, mission, values, and history.",
      data: [{ name : "description", content : "Learn more about Amerkila, a family-owned business that has been providing the best quality spices since 1985. Discover their vision, mission, values, and history."}]
    },
    "/products": {
        title: "The Premium Quality Spices Products - Amerkila",
        description: "Browse through the products of Amerkila, the leading spice brand that offers a range of roasted, evergreen, blended, and pickle spices that have a unique taste and unmatched quality.",
        data: [{ name : "description", content : "Browse through the products of Amerkila, the leading spice brand that offers a range of roasted, evergreen, blended, and pickle spices that have a unique taste and unmatched quality."}]
      },
      "/recipes": {
        title: "The Appetizing Recipes to Use Amerkila Spices",
        description: "Find out how to use Amerkila spices to create mouth-watering dishes from different cuisines. Amerkila has the perfect recipe for you. Explore their easy-to-follow recipes and enjoy the taste of spices.",
        data: [{ name : "description", content : "Find out how to use Amerkila spices to create mouth-watering dishes from different cuisines. Amerkila has the perfect recipe for you. Explore their easy-to-follow recipes and enjoy the taste of spices."}]
      },
      "/contact": {
        title: "Contact Us Amerkila for Any Enquiry",
        data: [{ name : "description", content : "Get in touch with Amerkila, Fill out the contact form or call their toll-free number to share your feedback, queries, or suggestions."}],
        description: "Get in touch with Amerkila, Fill out the contact form or call their toll-free number to share your feedback, queries, or suggestions."
      },
      "/products/amerkila-premium-compounded-asafoetida-bandhani-heeng":{
        title: "Compounded Asafoetida (Bandhani Heeng)",
        data: [{ name : "description", content : "Optimum mix of high quality Asafoetida (Heeng). It has strong flavor and small quantity is enough for making tasty dishes. Natural benefits of asafetida includes aiding digestion, helpful in treating asthama and bronchitis as well as reducing flatulence and other stomach problems"}]
      },
      "/products/amerkila-premium-chilli-powder-mirchi":{
        title: "Chilli Powder (Mirchi)",
        data: [{ name : "description", content : "Chilies of premium quality are finely grinded. It is a perfect blend of rich natural color and moderate pungency giving desirable flavor to your dishes."}]
      },
      "/products/amerkila-premium-turmeric-powder-haldi":{
        title: "Turmeric Powder (Haldi)",
        data: [{ name : "description", content : "Rajapuri quality Turmeric is finely grinded. It is Golden Yellow in colour and contains relatively high curcumin content compared to other qualities. Curcumin is the key active ingredient of turmeric and responsible for many of its benefits."}]
      },

      "/products/amerkila-premium-coriander-powder-dhaniya":{
        title: "Coriander Powder (Dhaniya)",
        data: [{ name : "description", content : "Amer Kila Coriander Powder is manufactured from special quality garden fresh Extra Green whole coriander seeds. Its lush green colour and aroma makes your dishes even more delicious and presentable. Whether its your child's favorite panner or your husbands favorite dum aloo no dish is complete without coriander powder as it plays a key role in making any dish even more tastier."}]
      },
      "/products/amerkila-premium-dry-mango-powder-amchoor":{
        title: "Dry Mango Powder (Amchoor)",
        data: [{ name : "description", content : "Amer kila amchoor powder is pale yellow in colour made from dried unripe mangoes of selected quality that have been grounded into a fine powder and is used in dishes to add mild sourness. It enhances the dish giving a tangy flavor to it and can be used in place of lemon for sprinkling on top of salads. It is used to add more flavour to curries, chutneys, soups and marinades"}]
      },
      "/products/achar-masala-pickle-spices-roasted-achar-masala":{
        title: "Roasted Achar Masala",
        data: [{ name : "description", content : "A relief for modern moms whose children drool over for pickles and she can't fulfill their desire, or an aid for modern wives whose husbands still relish the taste of pickles made by their mothers! ,Yes! making pickles is quite quick and easy with Amer Kila Roasted achaar masala .A unique blend of 11 spices for preparing various kinds of pickles. The process of blending involves processing with oil which gives special taste to the pickles. You can make pickles of Kairi (raw mango), Mirchi, Kair, Lheswe, Gajar etc. with this achaar masala. So just do it , when you feel like making it without worrying about the taste and bring a smile to your family."}]
      },
      "/products/achar-masala-pickle-spices-nimbu-achar-masala":{
        title: "Nimbu Achar Masala",
        data: [{ name : "description", content : "The citrusy flavor of lemon is liked by one and all and it comes along with its benefits . A unique blend of 21 traditional spices for preparing lemon pickles. It gives an exceptional sweet & sour taste to the lemon pickle. Just go through the steps for mixing the achar masala to prepare your tangy nimbu achar and here its ready for using it with your meals making it complete ."}]
      },
      "/products/achar-masala-pickle-spices-evergreen-achar-masala":{
        title: "Evergreen Achar Masala",
        data: [{ name : "description", content : "Making pickles is quite quick and easy with Evergreen achar masala. A unique blend of spices for preparing various kinds of pickles. The process of blending involves processing with oil which gives special taste to the pickles. Try it , when you feel like making it without worrying about the taste and bring a smile to your family."}]
      },
      "/products/blended-spices-garam-masala":{
        title: "Garam Masala",
        data: [{ name : "description", content : "Amer kila Garam masala is a unique mix of 10 spices with traditional Indian taste. It has original taste and quality as it is without additives like coriander powder or red chilli powder, and thus a small quantity adds the hot spicy ting to the vegetables and other dishes. It is generally sprinkled in a small quantity over the dishes when it is cooked. Garam masala ,with is strong flavor and aroma makes the dish even more tempting and delicious."}]
      },
      "/products/blended-spices-chai-masala":{
        title: "Chai Masala",
        data: [{ name : "description", content : "CHAI MASALA"}]
      },
      "/products/blended-spices-chaat-masala":{
        title: "Chaat Masala",
        data: [{ name : "description", content : "Chaat Masala"}]
      },
      "/products/blended-spices-chhole-masala":{
        title: "Chhole-Masala",
        data: [{ name : "description", content : "Chhole Masala"}]
      },
      "/products/blended-spices-sambhar-masala":{
        title: "Sambhar Masala",
        data: [{ name : "description", content : "Sambhar Masala"}]
      },
      "/products/blended-spices-pav-bhaji-masala":{
        title: "Pav Bhaji Masala",
        data: [{ name : "description", content : "Pav Bhaji Masala"}]
      },
      "/products/evergreen-chilli-powder-mirchi": {
        title: "Chilli Powder (Mirchi)",
        data: [{ name : "description", content : "Chillies of high quality originating from Guntur and dhamnod are finely grinded."}]
      },
      "/products/evergreen-turmeric-powder-haldi": {
        title: "Turmeric Powder (Haldi)",
        data: [{ name : "description", content : "Amer Kila Evergreen Turmeric Powder is manufactured from finest quality of Turmeric from Salem and Sangli. Its high curcumin content and bright yellow color enhances the flavor, taste and colour of dishes."}]
      },
      "/products/evergreen-coriander-powder-dhaniya": {
        title: "Coriander Powder (Dhaniya)",
        data: [{ name : "description", content : "Amer Kila evergreen coriander powder is manufactured from famous coriander of Ramganj Mandi. Known for its rich colour and flavor, the coriander powder enhances the aroma of dishes and adds to the taste of the food. It is basic ingredient for making variety of gravy and curry recipes."}]
      },
      "/products/evergreen-dry-mango-powder-amchoor": {
        title: "Dry Mango Powder (Amchoor)",
        data: [{ name : "description", content : "It is light brown in colour made from dried unripe mangoes of superior quality that have been grounded into a fine powder and is used in dishes to add mild sourness. It enhances the dish giving a tangy flavor to it and can be used in place of lemon for sprinkling on top of salads. It is used to add more flavour to curries, chutneys, soups and marinades"}]
      },
      "/acharialoor": {
        title: "Achari Aloo",
        data: [{ name : "description", content : "Achari Aloo : Potatoes tempered with spices"}]
      },
      "/acharibhindi": {
        title: "Achari Bhindi",
        data: [{ name : "description", content : "Achari Bhindi"}]
      },
      "/nimbukaachar": {
        title: "Nimbu Ka Achar",
        data: [{ name : "description", content : "Nimbu Ka Achar : LEMON PICKLE"}]
      },
      "/lheswekaachar": {
        title: "Lheswe Ka Achar",
        data: [{ name : "description", content : "Lheswe Ka Achar"}]
      },
      "/kerikaachar": {
        title: "Keri Ka Achar",
        data: [{ name : "description", content : "Keri Ka Achar : Raw Mango pickle"}]
      },
      "/mirchkaachar": {
        title: "Mirch Ka Achar",
        data: [{ name : "description", content : "Mirch Ka Achar : Pickled Green Chillies"}]
      }
      ,
      "/kerkaachar": {
        title: "Ker Ka Achar",
        data: [{ name : "description", content : "Ker Ka Achar : Indain Wild Berry Pickle"}]
      }
      ,
      "/gajarkaachar": {
        title: "Gajar Ka Achar",
        data: [{ name : "description", content : "Gajar Ka Achar : Carrot Pickle"}]
      }
      ,
      "/amlekaachar": {
        title: "Amle Ka Achar",
        data: [{ name : "description", content : "Amle Ka Achar : Gooseberry Pickle"}]
      },
      "/about-us/acharialoo": {
        title: "Achari Aloo",
        data: [{ name : "description", content : "Achari Aloo : Potatoes tempered with spices"}]
      },
      "/about-us/kerikaachar": {
        title: "Keri Ka Achar",
        data: [{ name : "description", content : "Keri Ka Achar : Raw Mango pickle"}]
      },
      "/about-us/mirchkaachar": {
        title: "Mirch Ka Achar",
        data: [{ name : "description", content : "Mirch Ka Achar : Pickled Green Chillies"}]
      },
      "/about-us/kerkaachar": {
        title: "Ker Ka Achar",
        data: [{ name : "description", content : "Ker Ka Achar : Indain Wild Berry Pickle"}]
      }
  
  };

